// Same rule the backend (batchPlanner) and web2 apply to emails.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const normalizeEmail = (value) => (value ?? '').trim().toLowerCase()

export const isEmail = (value) => EMAIL_RE.test(normalizeEmail(value))
